<script>

import {checkExtension, checkSize} from "@/components/libs/extension";

export default {
  name: "DropFile",
  props: {
    customData: Object,
    allowedExtension: Array,
  },
  emits: [
      'deleteFile'
  ],
  computed: {
    filename() {
      return this.customData.item.name
    },
    filesize() {
      return this.customData.item.size
    },
    truncFileSize() {

      const size = this.filesize
      const metric = this.metric
      // Math.trunc

      if(metric === 'B')
        return size

      if(metric === 'KB')
        return Math.trunc(size/1024)

      if(metric === 'MB')
        return Math.trunc(size/(1024*1024))

      if(metric === 'GB')
        return Math.trunc(size/(1024*1024*1024))

      return Math.trunc(size/(1024*1024))


    },

    metric() {

      const size = this.filesize

      if(size > 0 && size <= 1024 )
        return 'B'

      if(size > 1024 && size <= 1048576 )
        return 'KB'

      if(size > 1048576 && size <= 1073741824 )
        return 'MB'

      if(size > 1073741824 && size <= 1099511627776 )
        return 'GB'

      return 'B'

    },
  },
  mounted() {


    this.validateFile()

  },
  methods: {

    validateFile() {

      const name = this.filename
      const size = this.filesize

      const validExt = checkExtension({filename: name, allowedExtension: this.allowedExtension})

      const validSize = checkSize({size: size, maxSize: 1073741824})

      //убрать из списка, если не валидна хотя бы одна проверка
      if(!(validExt.success && validSize.success)) {
        const index =  this.customData.index
        this.$emit('deleteFile', {index})
      }

    },

    deleteFile() {

      const index =  this.customData.index

      // console.log('file index', index)
      this.$emit('deleteFile', {index})

    }

  }
}
</script>

<template>

  <div class="file-item">{{filename}} ({{truncFileSize}} {{ metric }})
    <span class="btn-close" @click="deleteFile"></span>
  </div>

</template>

<style scoped>

</style>